import React, { useEffect, useState } from "react";
import armreach from "./Img/page/goldencoco.webp";
import pixelcut1 from "./Img/page/pixelcut1.webp";
import balancegolden from "./Img/page/balancegolden.webp";
import finemotor from "./Img/page/finemotor.webp";
import curling from "./Img/page/curling.webp";
import response from"./Img/page/response.webp";

import "./Component.css";

const Data = [
  {
    items: [
      { image: curling, text: "Force Modulation & Control" }, 
      { image:response , text: "Response Time" },
      { image: pixelcut1, text: "Interactive Group Therapy" },
    ],
  },
  {
    items: [
      { image: armreach, text: "Full Arm Reach" },
      { image: balancegolden, text: "Balance & Pre-GAIT" },
      { image: finemotor, text: "Wrist Fine Motor" },
    ],
  },
];

function ImgPage() {
   const [isLargeScreen, setIsLargeScreen] = useState(() =>
        window.matchMedia("(min-width: 1280px)").matches
      );
    
      // Hook to listen for window resize and update the screen size state
      useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 1280px)");
        const handleChange = (e) => setIsLargeScreen(e.matches);
        mediaQuery.addEventListener("change", handleChange);
    
        // Clean up the event listener on unmount
        return () => {
          mediaQuery.removeEventListener("change", handleChange);
        };
      }, []);
  return (
    <>
     {isLargeScreen &&
    <div className="d-flex flex-column  bg-gray-light justify-content-evenly upy-5 m-0">
      {Data.map((section, sectionIndex) => (
        <div
          key={sectionIndex}
          className="d-flex flex-row justify-content-evenly upy-10 "
        >
          {section.items.map(({ image, text }, index) => (
            <div
              key={index}
              className="position-relative d-flex  box-shadow upy-10 m-0 p-0 br-5 uh-120 uw-80 justify-content-center outer-div"
            >
              {/* Image */}
              <div
                className="image-container br-5 uh-120 uw-80"
                style={{
                  backgroundImage: `url(${image})`, 
                  backgroundSize: "cover",
                  backgroundPosition: "center",
            
                }}
              ></div>

              {/* Text Overlay */}
              <div className="position-absolute text-overlay  m-0 upy-10 upx-10 uh-40 uw-80 d-flex"
              style={{
                // ...(text === "Response Time" && {
                //   color: "#f2f2f2",
                //   borderTopLeftRadius: "calc(var(--unit) * 5)", 
                //   borderTopRightRadius: "calc(var(--unit) * 5)", 
                // }),
                ...(text === "Interactive Group Therapy" && {
                 
                  backgroundImage:
                    "linear-gradient(to bottom, rgba(255,255,255,0.7) 66%, rgba(255,255,255,0) 100%)",
                    borderTopLeftRadius: "calc(var(--unit) * 5)", 
                    borderTopRightRadius: "calc(var(--unit) * 5)",   
                }),
                ...(text === "Force Modulation & Control" && {
                  color: "#f2f2f2",
                  backgroundImage:
                  "linear-gradient(to bottom, rgba(0,0,0,0.4) 66%, rgba(255,255,255,0) 100%)",
                  borderTopLeftRadius: "calc(var(--unit) * 5)", 
                  borderTopRightRadius: "calc(var(--unit) * 5)", 
                }),
                ...(text === "Balance & Pre-GAIT" && {
                  
                  backgroundImage:
                    "linear-gradient(to bottom, rgba(255,255,255,0.7) 66%, rgba(255,255,255,0) 100%)",
                    borderTopLeftRadius: "calc(var(--unit) * 5)", 
                    borderTopRightRadius: "calc(var(--unit) * 5)",   
                }),
                
              }}
            >
                <p className=" m-0 p-0 fw-bold ufs-6 lh-sm ">{text}</p>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
    }{!isLargeScreen &&
      <div className="d-flex flex-column  bg-gray-light justify-content-evenly upy-5 m-0">
      {Data.map((section, sectionIndex) => (
        <div
          key={sectionIndex}
          className="d-flex flex-column align-items-center  upy-10 m-0 "
        >
          {section.items.map(({ image, text }, index) => (
            <div
              key={index}
              className="position-relative d-flex   m-4 upx-10 br-10 uh-400  w-100 justify-content-center outer-div"
            >
              {/* Image */}
              <div
                className="image-container br-10 uh-400 w-100 m-0 p-0 box-shadow"
                style={{
                  backgroundImage: `url(${image})`, 
                  backgroundSize: "cover",
                  backgroundPosition: "center",
            
                }}
              ></div>

              {/* Text Overlay */}
              <div className="position-absolute text-overlay upy-20 upx-20 m-0 uh-144 uw-300 d-flex"
              style={{
                // ...(text === "Response Time" && {
                //   color: "#f2f2f2",
                //   borderTopLeftRadius: "calc(var(--unit) * 5)", 
                //   borderTopRightRadius: "calc(var(--unit) * 5)", 
                // }),
                ...(text === "Interactive Group Therapy" && {
                 
                  backgroundImage:
                    "linear-gradient(to bottom, rgba(255,255,255,0.7) 66%, rgba(255,255,255,0) 100%)",
                    borderTopLeftRadius: "calc(var(--unit) * 10)", 
                    borderTopRightRadius: "calc(var(--unit) * 10)",   
                }),
                ...(text === "Force Modulation & Control" && {
                  color: "#f2f2f2",
                  backgroundImage:
                  "linear-gradient(to bottom, rgba(0,0,0,0.4) 66%, rgba(255,255,255,0) 100%)",
                  borderTopLeftRadius: "calc(var(--unit) * 10)", 
                  borderTopRightRadius: "calc(var(--unit) * 10)", 
                }),
                ...(text === "Balance & Pre-GAIT" && {
                  
                  backgroundImage:
                    "linear-gradient(to bottom, rgba(255,255,255,0.7) 66%, rgba(255,255,255,0) 100%)",
                    borderTopLeftRadius: "calc(var(--unit) * 10)", 
                    borderTopRightRadius: "calc(var(--unit) * 10)",   
                }),
                
              }}
            >
                <p className=" m-0 p-0 fw-bold ufs-14 lh-sm ">{text}</p>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
    }
    </>
   
  );
}

export default ImgPage;
